import { useEffect, useState } from "react";
import { useRouter } from "../../../hooks/router";

import Account from "./Fields/Account";
import Balance from "./Fields/Balance";
import EditProfile from "./Fields/EditProfile";
import HelpInfo from "./Fields/HelpInfo";
import SidebarSettings from "./SidebarSettings";

import './Settings.scss'
import './mediaSettings.scss'

import icon_account from './images/account.png'
import icon_edit from './images/edit.png'
import icon_payment from './images/subscription.png'
import icon_help_info from './images/help.png'
import icon_logout from './images/logout.png'
import icon_chat from './images/chatting.png'
import icon_login from './images/login.png'

import Modal from "../Modal/Modal";
import { translateWord } from "../../Util/util";
import { get_profile, get_tariff, get_pricing_items } from "../../../server/requests";
import Payment from "./Fields/Payment";
import History from "./Fields/History";
import Chat from "./Fields/Chat/Chat";

export default function Settings({
    setNotReadMessagesCount,
    adminReadAllMessages,
    configs,
    appSettings,
    notReadMessagesCount,
    isGuest
}) {

    const router = useRouter()

    const [activePage, setActivePage] = useState('account')
    const [logOut, setLogOut] = useState(false)
    const [profile, setProfile] = useState('')
    const [showLoading, setShowLoading] = useState(false)
    const [tariffName, setTariffName] = useState(false)
    const [tariffList, setTariffList] = useState([])
    const [showSidebarSettings, setShowSidebarSettings] = useState(false)

    const [navBarSettings, setNavBarSettings] = useState([
        { id: 0, icon: icon_account, title: 'Account', query: 'account', active: false },
        { id: 5, icon: icon_chat, title: 'Messages', query: 'messages', active: false },
        { id: 1, icon: icon_edit, title: 'Edit Profile', query: 'edit', active: false },
        { id: 2, icon: icon_payment, title: 'Payment', query: 'payment', active: false },
        { id: 3, icon: icon_help_info, title: 'Help & Info', query: 'help', active: false },
        { id: 4, icon: icon_logout, title: 'Logout', query: '', active: false },
    ])

    useEffect(() => {
        localStorage.removeItem('showLogin')

        if (profile == '') {



            if (!isGuest) {

                setShowLoading(true)

                get_profile({}, res => {
                    setShowLoading(false)
                    setProfile(res)
                }, err => console.log(err, 'error'))

                get_tariff({}, res => {
                    setTariffName(res.name)
                }, err => console.log(err, 'error'))

                get_pricing_items({}, res => {
                    console.log(res, 'res tariff')
                    setTariffList([...res])
                })
                
            } else {
                setNavBarSettings([
                    { id: 3, icon: icon_help_info, title: 'Help & Info', query: 'help', active: false },
                    { id: 10, icon: icon_login, title: 'Sign In', query: '', active: false },
                ])
            }


        }

    }, [])


    useEffect(() => {

        if (!router.query.a) {
            if (isGuest) router.push('/settings?a=help')
            else router.push('/settings?a=account')
        } else {

            const newArray = [...navBarSettings]

            const active_setting = newArray.find(e => e.query == router.query.a)
            const prevActive = newArray.find(e => e.active == true)

            if (active_setting) {
                if (prevActive) prevActive.active = false

                active_setting.active = true
                setActivePage(active_setting.query)

            } else {
                newArray[0].active = true
                setActivePage(router.query.a)
            }

            if (appSettings && !appSettings.lessons) {

                let new_array = [...navBarSettings]

                let mess = newArray.find(e => e.query == 'messages')
                let index = null

                if (mess) {
                    index = new_array.indexOf(mess)
                    newArray.splice(index, 1)
                }

            }

            setNavBarSettings([...newArray])

        }

    }, [router.query])

    const click_settings_item = (elem) => {

        if (elem.title == 'Balance') {
            router.push('/settings?a=balance')
            return
        } else if (elem.title == 'History') {
            router.push('/settings?a=history')
            return
        }


        if (elem.title != 'Logout' && elem.id != 10) router.push('/settings?a=' + elem.query)

        else {
            if (elem.title == 'Logout') setLogOut(true)
            else {
                localStorage.setItem('showLogin', true)
                router.push('/auth')
            }
        }

    }

    const btnConfirmLogOut = () => {
        let active_lang = JSON.parse(localStorage.getItem('language'))
        let background = localStorage.getItem('background_image')
        let device_id = localStorage.getItem('device_id')

        localStorage.clear()

        localStorage.setItem('language', JSON.stringify(active_lang))
        localStorage.setItem('background_image', background)
        localStorage.setItem('device_id', device_id)

        setLogOut(false)
        let _redirected_url = configs.help_page.replace('{{lang}}', active_lang.iso_code)
        window.location.href = _redirected_url

    }
    const btnCancelLogOut = () => setLogOut(false)

    return (
        <div className="container">
            <SidebarSettings
                click_settings_item={click_settings_item}
                navBarSettings={navBarSettings}
                showSidebarSettings={showSidebarSettings}
                setShowSidebarSettings={setShowSidebarSettings}
                notReadMessagesCount={notReadMessagesCount}
            />
            {logOut ?
                <Modal
                    btnConfirm={btnConfirmLogOut}
                    btnCancel={btnCancelLogOut}
                    btnConfirmText={translateWord('Yes')}
                    btnCancelText={translateWord('No')}
                    title={translateWord('Are you sure that you want to sign out?')}
                />
                : null}
            <img src="" alt="" />
            <div className="parent_settings" onClick={() => showSidebarSettings ? setShowSidebarSettings(false) : null}>
                <div className="navbar_settings">
                    {navBarSettings.map((e, i) => {

                        let className_ = ''

                        e.query == 'payment' && !appSettings.enable_payment ? className_ = 'hide' : className_ = ''

                        return (
                            <div
                                key={e.id}
                                className={"nav_settings_item card_color " + className_}
                                style={{ borderColor: e.active ? 'white' : "transparent" }}
                                onClick={() => click_settings_item(e)}
                            >
                                <div className="parent_icon_nav_settings">
                                    {
                                        notReadMessagesCount && e.query == 'messages' ?
                                            <div className="unread_message_count_nav">

                                            </div>
                                            : null
                                    }
                                    <img src={e.icon} alt="" />
                                </div>
                                <p>{translateWord(e.title)}</p>
                                <div className={e.active ? "arrow_active_set active" : "arrow_active_set"}></div>
                            </div>
                        )
                    })}
                </div>

                <div className="main_settings">

                    {activePage == 'history' ? <History currency={(profile ? profile.currency.symbol : '')} /> :
                        activePage == 'balance' ? <Balance appSettings={appSettings} /> :
                            activePage == 'account' ? <Account
                                appSettings={appSettings}
                                profile={profile}
                                showLoading={showLoading}
                                tariffName={tariffName}
                                click_settings_item={click_settings_item}
                            /> :
                                activePage == 'edit' ? <EditProfile /> :
                                    activePage == 'payment' ? <Payment tariffs={tariffList} /> :
                                        activePage == 'messages' ?
                                            <Chat
                                                setNotReadMessagesCount={setNotReadMessagesCount}
                                                adminReadAllMessages={adminReadAllMessages}
                                                tariffs={tariffList}
                                            /> :
                                            <HelpInfo configs={configs} />
                    }

                </div>
            </div>
        </div>
    )
}